import { z } from 'zod';

export const PlanZod = z
    .object({
        annual_fee: z.number(),
        context: z.string(),
        couple: z.boolean(),
        subscription_start_date: z.number(),
        one_time_fee: z.number().optional(),
    })
    .and(
        z.union([
            z.object({
                plan_code: z.literal('gift_trust'),
                product: z.literal('gift_trust'),
                product_choice: z.literal('gift_trust_choice'),
            }),
            z.object({
                plan_code: z.union([z.literal('simple_will_single'), z.literal('simple_will_couple')]),
                product: z.literal('simple_will'),
                product_choice: z.literal('simple_product_choice'),
            }),
            z.object({
                plan_code: z.union([z.literal('custom_will_single'), z.literal('custom_will_couple')]),
                product: z.literal('custom_will'),
                product_choice: z.literal('custom_product_choice'),
            }),
            z.object({
                plan_code: z.union([z.literal('living_trust_single'), z.literal('living_trust_couple')]),
                product: z.literal('living_trust'),
                product_choice: z.literal('trust_product_choice'),
            }),
        ]),
    );

export type Plan = z.infer<typeof PlanZod>;
